
/**
 * The FeaturedHomeBlocks will be transformed into
 * a slider on mobile screens
 */
export class FeaturedHomeBlocks {

  constructor() {
    this.initSlider();
  }

  initSlider() {
    $('.featured-home-blocks__container').slick({
      infinite: false,
      autoplay: false,
      arrows: false,
      swipe: true,
      dots: true,
      speed: 350,
      fade: false,
      cssEase: 'linear',
      // on desktop show 3 slides at a time
      slidesToShow: 3,
      // show only 1 slide on mobile screens
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
}
